import { useEffect, useRef } from 'react'
import { Button, Fa, Modal } from '@eltoro-ui/components'
import { useNavigate } from 'react-router-dom'
import { trackEvent } from 'Hooks/usePostHog'
import dpaPDF from '../../Assets/Legal/Data Processing Agreement.pdf'
import './DPAPage.scss'

const DOCUMENT_TYPE = 'data_processing_agreement'
const DOCUMENT_VERSION = '1.1'
const PORTAL = 'gen3'

export const DPAPage = () => {
  const navigate = useNavigate()
  const viewTracked = useRef(false)
  const downloadInFlight = useRef(false)

  useEffect(() => {
    if (viewTracked.current) return
    viewTracked.current = true
    trackEvent('legal_document_viewed', {
      document_type: DOCUMENT_TYPE,
      document_version: DOCUMENT_VERSION,
      portal: PORTAL,
    })
  }, [])

  const handleClose = () => {
    if (window.history.state && window.history.state.idx > 0) navigate(-1)
    else navigate('/')
  }

  const handleDownloadPDF = () => {
    if (downloadInFlight.current) return
    downloadInFlight.current = true
    trackEvent('legal_document_downloaded', {
      document_type: DOCUMENT_TYPE,
      document_version: DOCUMENT_VERSION,
      portal: PORTAL,
    })

    const a = document.createElement('a')
    a.href = dpaPDF
    a.download = 'el_toro_data_processing_agreement.pdf'
    document.body.appendChild(a)
    a.style.display = 'none'
    a.click()
    document.body.removeChild(a)

    setTimeout(() => {
      downloadInFlight.current = false
    }, 500)
  }

  return (
    <Modal
      offClick={handleClose}
      header={<p>Data Processing Agreement</p>}
      className="DPAPage__modal min-w-[80%]"
      classNameContent="DPAPage__modal-content"
    >
      <div className="DPAPage flex h-full flex-col">
        <div className="DPAPage__iframe-container relative m-auto h-full w-full flex-1">
          <iframe
            src={`${dpaPDF}#view=FitH&toolbar=0&navpanes=0`}
            title="El Toro Data Processing Agreement"
            className="DPAPage__pdf-container h-full w-full"
          >
            <p>
              This browser does not support PDFs. Please download the Data
              Processing Agreement using the button below.
            </p>
          </iframe>
        </div>
        <div className="DPAPage__footer sticky bottom-0 flex flex-col py-3">
          <div className="flex flex-wrap justify-between">
            <span
              aria-label="Download a copy of the data processing agreement"
              data-tooltip="right"
            >
              <Button
                onClick={handleDownloadPDF}
                iconLeft={<Fa icon="file-arrow-down" size={1} />}
              >
                Download PDF
              </Button>
            </span>
          </div>
        </div>
      </div>
    </Modal>
  )
}
